<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />
          <Button
            label="Post"
            size="md"
            class="mt-0"
            @click="goToAddChequeWithdrawal"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <Button
              label="Filter"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />
            <Button
              label="Reset Filter"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="cashWithdrawalRef"
      :items="cashWithdrawalList"
      responsive
      :busy="isBusy"
      :per-page="pageSize"
      :current-page="currentPage"
      :fields="tableHeaders"
      primary-key="id"
      show-empty
      empty-text="No records available"
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>

      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>

      <!-- Column: credit -->
      <template #cell(amount)="data">
        {{ toBalance(data.value) }}
      </template>

      <!-- Column: financial date -->
      <template #cell(financialDate)="data">
        {{ data.value ? toDateWithYear(data.value) : '' }}
      </template>

      <!-- Column: transaction date -->
      <template #cell(transactionDate)="data">
        <p class="mb-0">
          {{ data.value ? toDateWithTime(data.value) : '' }}
        </p>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <feather-icon
          icon="EyeIcon"
          class="cursor-pointer"
          @click="onViewCashWithdrawal(data.item)"
        />
      </template>

    </b-table>

    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />

    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      title="Cheque Withdrawal"
      ok-title="Print Receipt"
      no-close-on-backdrop
      cancel-title="Cancel"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      modal-footer
      hide-footer
    >

      <div class="text-center">
        <h3>Posting Reference: {{ chequeWithdrawalData.postingReferenceNumber }}</h3>
      </div>

      <TableEntries
        v-model="transactionPerPage"
        :options="perPageOptions"
      />

      <b-table
        ref="reverseTransactionRef"
        :items="transactionList"
        responsive
        :busy="isBusy"
        :per-page="transactionPageSize"
        :current-page="transactionCurrentPage"
        :fields="transactionTableHeaders"
        primary-key="id"
        show-empty
        empty-text="No records available"
        class="position-relative mt-3"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner
              class="align-middle"
              variant="primary"
            />
          </div>
        </template>

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

      </b-table>

      <TablePagination
        v-model="transactionCurrentPage"
        :from="transactionFrom"
        :to="transactionTo"
        :total-rows="transactionTotalEntries"
        :per-page="transactionPerPage"
      />
      <hr>
      <div class="d-flex align-items-center justify-content-lg-end">
        <Button
          label="Cancel"
          size="md"
          class="mr-1"
          variant="outline-secondary"
          @click="cancelButton"
        />
        <Button
          label="POS Printer"
          size="md"
          icon="PrinterIcon"
          show-icon
          class="mr-1"
          @click="posPrintReceipt"
        />
        <Button
          label="Billing Printer"
          size="md"
          icon="PrinterIcon"
          show-icon
          @click="billingPrintReceipt"
        />
      </div>
    </b-modal>
    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      ok-title="Apply"
      no-close-on-backdrop
      cancel-title="Cancel"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      title="Filters"
      modal-footer
      @ok="fetchChequeWithdrawal"
      @cancel="resetFilters"
    >
      <b-row class="match-height">
        <!-- Account Name -->
        <b-col md="6">
          <InputField
            id="account-name"
            v-model="filter.accountName"
            label="Account Name"
            placeholder="Enter account name"
            type="text"
            onpaste="return false;"
            :is-allow-special-characters="false"
          />
        </b-col>
        <!-- Account Name -->

        <!-- Account Number -->
        <b-col md="6">
          <InputField
            id="account-number"
            v-model="filter.accountNumber"
            label="Account Number"
            placeholder="Enter account number"
            type="text"
          />
        </b-col>
        <!-- Account Number -->

        <!--Posting Reference Number -->
        <b-col md="6">
          <InputField
            id="reference-number"
            v-model="filter.postingReferenceNumber"
            label="Reference Number"
            placeholder="Enter posting reference number"
            type="text"
          />
        </b-col>
        <!-- Posting Reference Number -->

        <!-- Instrument Number -->
        <b-col md="6">
          <InputField
            id="instrument-number"
            v-model="filter.instrumentNumber"
            label="Instrument Number"
            placeholder="Enter instrument number"
            type="text"
            for="instrument-number"
          />
        </b-col>
        <!-- Instrument Number -->

        <!-- Entry Number -->
        <b-col md="6">
          <InputField
            id="entry-number"
            v-model="filter.entryCode"
            label="Entry Number"
            placeholder="Enter entry number"
            type="number"
          />
        </b-col>
        <!-- Entry Number -->

        <!-- GL code -->
        <b-col md="6">
          <InputField
            id="gl-code"
            v-model="filter.glCode"
            label="GL Code"
            placeholder="Enter gl code"
            type="text"
          />
        </b-col>
        <!-- GL code -->

        <!-- Branch -->
        <!-- <b-col md="6">
          <SelectField
            id="branch"
            v-model="filter.branchCode"
            label="Branch"
            placeholder="Select Branch"
            :options="branchOptions"
            :reduce="option => option.value"
            item="label"
          />
        </b-col> -->
        <!-- Branch -->

        <!-- Financial Date From -->
        <b-col md="6">
          <DatePickerField
            id="date-of-public-holiday"
            v-model="filter.financialDateFrom"
            label="Financial Date"
            :config="datePickerConfig"
          />
        </b-col>
        <!-- Financial Date From-->

        <!-- Financial Date To -->
        <b-col md="6">
          <DatePickerField
            id="date-of-public-holiday"
            v-model="filter.financialDateTo"
            label="Financial Date"
            :config="datePickerConfig"
          />
        </b-col>
        <!-- Financial Date To-->

        <!-- Start Date -->
        <b-col md="6">
          <DatePickerField
            id="start-date"
            v-model="filter.startDate"
            label="Start Date"
            :config="datePickerConfig"
          />
        </b-col>
        <!-- Start Date -->

        <!-- End Date -->
        <b-col md="6">
          <DatePickerField
            id="end-date"
            v-model="filter.endDate"
            label="End Date"
            :config="datePickerConfig"
          />
        </b-col>
        <!-- End Date -->
      </b-row>
    </b-modal>
    <!-- Filter modal -->

    <!-- Print Transaction Receipt -->
    <div
      id="transaction-receipt-print"
    >
      <p id="prints">

        <b-card>
          <b-row
            no-gutters
          >
            <b-col
              md="12"
              style="text-align: center; margin-top: -70px;"
            >
              <img
                :src="userDetails.institutionLogoURL ? userDetails.institutionLogoURL : ''"
              >
              <p
                v-if="corporateDetails"
                style="font-size: 2rem; text-align: center;"
                class="mt-2"
              >
                {{ corporateDetails.registeredAddress }}
              </p>
              <p
                style="font-family: 'Gill Sans Extrabold', sans-serif; font-size: 4rem; font-weight: 600; text-align: center;"
                class="mt-4"
              >
                Transaction Receipt
              </p>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col
              md="8"
              :style="printerFirstStyle"
            >
              <div class="watermark">
                <b-card-body>
                  <b-card-text>
                    <div class="watermark__inner">
                      <div class="watermark__body">
                        {{ corporateDetails.registeredName }}
                      </div>
                    </div>
                    <table
                      :style="printerSecondStyle"
                      style="display: table; table-layout: fixed;"
                    >
                      <tbody>
                        <tr>
                          <td style="font-size: 3rem; padding-top: 5rem; color:#000;">
                            Transaction Type
                          </td>
                          <td style="text-align: right; font-size: 3rem; padding-top: 5rem; font-weight: 700; color:#000">
                            Cheque Withdrawal
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 3rem; color:#000; padding-top: 5rem;">
                            Account Number
                          </td>
                          <td style="text-align: right; font-size: 3rem; padding-top: 5rem; color:#000; font-weight: 600; text-transform: capitalize; line-height: 1;">
                            {{ chequeWithdrawalData.accountNumber }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 3rem; color:#000; padding-top: 5rem;">
                            Account Name
                          </td>
                          <td style="text-align: right; font-size: 3rem; padding-top: 5rem; color:#000; font-weight: 600; line-height: 1;">
                            {{ chequeWithdrawalData.accountName }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 3rem; padding-top: 5rem; color:#000;">
                            Amount
                          </td>
                          <td style="text-align: right; font-size: 3rem; padding-top: 5rem; font-weight: 700; color:#000; line-height: 1;">
                            {{ toBalance(chequeWithdrawalData.amount) }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 3rem; color:#000; padding-top: 5rem;">
                            Branch
                          </td>
                          <td style="text-align: right; font-size: 3rem; padding-top: 5rem; color:#000; font-weight: 600; line-height: 1;">
                            {{ chequeWithdrawalData.branch }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 3rem; padding-top: 5rem; color:#000;">
                            Instrument Number
                          </td>
                          <td style="text-align: right; font-size: 3rem; padding-top: 5rem; color:#000; font-weight: 600; line-height: 1;">
                            {{ chequeWithdrawalData.instrumentNumber }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 3rem; padding-top: 5rem; color:#000;">
                            Posting Reference
                          </td>
                          <td style="text-align: right; font-size: 3rem; padding-top: 5rem; color:#000; font-weight: 600; line-height: 1;">
                            {{ chequeWithdrawalData.postingReferenceNumber }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 3rem; padding-top: 5rem; color:#000;">
                            Details
                          </td>
                          <td style="text-align: right; font-size: 3rem; padding-top: 5rem; color:#000; font-weight: 600; line-height: 1;">
                            {{ chequeWithdrawalData.narration }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 3rem; padding-top: 5rem; color:#000;">
                            Teller
                          </td>
                          <td style="text-align: right; font-size: 3rem; padding-top: 5rem; color:#000; font-weight: 600; line-height: 1;">
                            {{ chequeWithdrawalData.initiator }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 3rem; padding-top: 5rem; color:#000;">
                            Transaction Date
                          </td>
                          <td style="text-align: right; font-size: 3rem; padding-top: 5rem; color:#000; font-weight: 600; line-height: 1;">
                            {{ chequeWithdrawalData.transactionDate ? chequeWithdrawalData.transactionDate : '' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-card-text>
                </b-card-body>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </p>
    </div>
    <!-- Print Transaction Receipt -->

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BCardBody, BCardText, BRow, BCol, BTable, BSpinner,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import TablePagination from '@/views/components/table/TablePagination.vue'
import { toAmount, toBalance } from '@/helpers/formatAmount'
import TableEntries from '@/views/components/table/TableEntries.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toDateWithYear, toDateWithTime } from '../../../../../helpers/formatDate'
import InputField from '../../../../forms/InputField.vue'
import DatePickerField from '../../../../forms/DatePickerField.vue'
import Button from '../../../../components/button/Button.vue'
import { postingPermissions } from '../../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BCardBody,
    BCardText,
    BRow,
    BCol,
    BSpinner,
    BTable,
    TablePagination,
    FullScreenSpinner,
    InputField,
    DatePickerField,
    Button,
    TableEntries,
  },
  mixins: [modalMixins, tableMixins, sweetAlert],
  data() {
    return {
      toDateWithYear,
      toDateWithTime,
      toAmount,
      toBalance,
      required,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountNumber', sortable: true },
        { key: 'accountName', sortable: true },
        { key: 'branch', sortable: true },
        { key: 'financialDate', sortable: true },
        { key: 'transactionDate', sortable: true },
        { key: 'postingReferenceNumber', sortable: true, label: 'Posting Reference' },
        { key: 'amount', sortable: true },
        { key: 'entryCode', sortable: true, label: 'Sort Code' },
        { key: 'instrumentNumber', sortable: true },
        { key: 'senderName', sortable: true },
        { key: 'initiatedBy', sortable: true },
        { key: 'narration', sortable: true },
        { key: 'approvedBy', sortable: true, label: 'Approver' },
        { key: 'actions' },
      ],
      transactionTableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountNumber', sortable: true },
        { key: 'accountName', sortable: true },
        { key: 'debit', sortable: true },
        { key: 'credit', sortable: true },
        { key: 'branch', sortable: true },
        { key: 'instrumentNumber', sortable: true },
        { key: 'entryCode', sortable: true, label: 'Sort Code' },
      ],
      categoryFormData: {
        categoryName: '',
        level: 'Select',
        specifyLevel: 'Select',
      },
      tillAccountNumber: '',
      chequeWithdrawalData: {
        accountNumber: '',
        accountName: '',
        branch: '',
        financialDate: '',
        transactionDate: '',
        postingReferenceNumber: '',
        credit: '',
        entryCode: '',
        instrumentNumber: '',
        senderName: '',
        narration: '',
        approver: '',
        initiatedBy: '',
        initiator: '',
      },
      filter: {
        accountName: null,
        accountNumber: null,
        postingReferenceNumber: null,
        instrumentNumber: null,
        branchCode: null,
        financialDateFrom: null,
        financialDateTo: null,
        startDate: null,
        endDate: null,
        entryCode: null,
        glCode: null,
        recordType: null,
        postingType: 'ChequeWithdrawalPosting',
      },
      datePickerConfig: {
        dateFormat: 'Y-m-d',
      },
      branchOptions: [],
      cashWithdrawalList: [],
      transactionList: [],
      transactionPerPage: 10,
      transactionPageSize: 0,
      transactionCurrentPage: 1,
      transactionTotalCount: 0,
      showSpinner: false,
      postingReferenceNumber: null,
      corporateDetails: {},
      printerFirstStyle: {
        width: '',
        marginLeft: '',
        marginRight: '',
      },
      printerSecondStyle: {
        width: '',
        marginLeft: '',
        marginRight: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      userDetails: 'auth/getCurrentUser',
      tillAccount: 'operations/getTillAccount',
    }),
    totalEntries() {
      return this.totalCount
    },
    numberOfPages() {
      return Math.floor((this.totalEntries + this.perPage - 1) / this.perPage)
    },
    from() {
      return (this.currentPage * this.perPage) - (this.perPage - 1)
    },
    to() {
      return Math.min(this.from + this.perPage - 1, this.totalEntries)
    },
    transactionTotalEntries() {
      return this.transactionTotalCount
    },
    transactionNumberOfPages() {
      return Math.floor((this.transactionTotalEntries + this.transactionPerPage - 1) / this.transactionPerPage)
    },
    transactionFrom() {
      if (this.transactionTotalCount === 0) {
        return 0
      }
      return (this.transactionCurrentPage * this.transactionPerPage) - (this.transactionPerPage - 1)
    },
    transactionTo() {
      return Math.min(this.transactionFrom + this.transactionPerPage - 1, this.transactionTotalEntries)
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.fetchChequeWithdrawal()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.fetchChequeWithdrawal()
    },
    transactionCurrentPage(newValue) {
      this.transactionCurrentPage = newValue
      this.fetchPostings(this.postingReferenceNumber)
    },
    transactionPerPage(newValue) {
      this.transactionPerPage = newValue
      this.fetchPostings(this.postingReferenceNumber)
    },
  },
  mounted() {
    this.fetchChequeWithdrawal()
    this.fetchCorporateInformation()
  },
  methods: {
    ...mapActions({
      getPostingsReport: 'reports/getTransactionReports',
      getTillAccountList: 'operations/getTillAccountList',
      getCorporateInformation: 'operations/getCorporateInformationList',
    }),
    posPrintReceipt() {
      this.printerFirstStyle = {
        width: '100%',
        marginLeft: '5%',
        marginRight: '5%',
      }
      this.printerSecondStyle = {
        width: '100%',
        marginLeft: '0%',
        marginRight: '0%',
      }
      setTimeout(() => {
        window.print()
      }, 200)
    },
    billingPrintReceipt() {
      this.printerFirstStyle = {
        width: '100%',
        marginLeft: '0%',
        marginRight: '0%',
      }
      this.printerSecondStyle = {
        width: '100%',
        marginLeft: '0%',
        marginRight: '0%',
      }
      setTimeout(() => {
        window.print()
      }, 200)
    },
    cancelButton() {
      this.hideModal('modal-lg')
    },
    async goToAddChequeWithdrawal() {
      this.$router.push('cheque-withdrawal')
    },
    async fetchCorporateInformation() {
      try {
        const response = await this.getCorporateInformation({
          permission: postingPermissions.VIEW_CHEQUE_WITHDRAWAL_POSTING,
        })
        const { status, data } = response
        if (status === 200 && data) {
          this.corporateDetails = {
            registeredName: data.data.registeredName,
            registeredAddress: data.data.registeredAddress,
          }
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    async fetchChequeWithdrawal() {
      try {
        this.isBusy = true
        const response = await this.getPostingsReport({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
          route: 'postingsReport',
          permission: postingPermissions.VIEW_CHEQUE_WITHDRAWAL_POSTING,
          type: 'entryCode',
          entryCodes: ['D-CHQW', 'D-CSOW'],
        })
        const { data, status } = await response
        if (status === 200 && data.data) {
          this.isBusy = false
          this.cashWithdrawalList = data.data
          this.totalCount = data.recordCount
        } else {
          this.cashWithdrawalList = []
          this.totalCount = 0
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async fetchPostings(postingReferenceNumber) {
      const response = await this.getPostingsReport({
        search: { postingReferenceNumber },
        page: this.transactionCurrentPage,
        limit: this.transactionPerPage,
        route: 'postingsReport',
        permission: postingPermissions.VIEW_CHEQUE_WITHDRAWAL_POSTING,
      })
      const { data, status } = response
      if (status === 200 && data.data) {
        this.transactionList = data.data.map(item => ({
          ...item,
          credit: toBalance(item.credit),
          debit: toBalance(item.debit),
        }))
        this.transactionTotalCount = data.recordCount
      }
    },
    async onViewCashWithdrawal(items) {
      try {
        this.showSpinner = true
        this.postingReferenceNumber = items.postingReferenceNumber
        await this.fetchPostings(items.postingReferenceNumber)

        this.chequeWithdrawalData = {
          ...items,
          transactionDate: this.toDateWithYear(items.transactionDate),
          financialDate: this.toDateWithYear(items.financialDate),
          credit: toBalance(items.credit),
        }
        this.$root.$emit('bv::show::modal', 'modal-lg')
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },

    resetFilters() {
      this.filter = {
        ...null,
        entryCodes: ['D-CHQW', 'D-CSOW'],
        postingType: 'ChequeWithdrawalPosting',
      }
    },
    resetFilter() {
      this.filter = {
        ...null,
        entryCodes: ['D-CHQW', 'D-CSOW'],
        postingType: 'ChequeWithdrawalPosting',
      }
      this.fetchChequeWithdrawal()
    },
  },
}
</script>
<style lang="scss">
      @media screen {
  #prints {
    display: none;
   }
}

@media print {
   html, body {
     height: 99%;
     page-break-after: avoid !important;
     page-break-before: avoid !important;
     visibility:hidden;
  }
  #transaction-receipt-print, #transaction-receipt-print * {
    visibility: visible; border: none;
  }
  #prints, #prints * {
    visibility:visible;
  }
  #prints {
    position:absolute;
    left:0;
    top:0;
    right: 0;
  }
  img {
  max-width: 20%;
  height: auto;
}
}
.watermark {
    position: relative;
}
.watermark__inner {
    /* Center the content */
    align-items: center;
    display: flex;
    justify-content: center;

    /* Absolute position */
    position: absolute;
    left: 100px;
    top: 0px;
    height: 100%;
    width: 100%;
}

.watermark__body {
  color: rgba($color: #333232, $alpha: 0.3);
    font-size: 5.3rem;
    font-weight: bold;
    white-space: nowrap;
    text-transform: capitalize;
    font-family: "Gill Sans Extrabold", sans-serif !important;
    /* Rotate the text */
    transform: rotate(-60deg);

    /* Disable the selection */
    user-select: none;
}
</style>
